import { valueBetweenBracesRegExp } from "modules/GenerateByUIConfigurationModule/generateByUIConfiguration.consts";
import { findAndRemoveRegExp } from "modules/GenerateByUIConfigurationModule/helpers/findAndRemoveRegExp";

export const getKeysFromTemplate = (template: string) => {
  const [, result] = findAndRemoveRegExp(template, valueBetweenBracesRegExp);
  return result.map(([, relationKeysFromTemplate]) => relationKeysFromTemplate) || [];
};
